module.exports = __webpack_public_path__ + "logo_assystem.png?bc98604779f0f5c9a276322cc3b3f823";


//////////////////
// WEBPACK FOOTER
// ./src/img/confiance/logo_assystem.png
// module id = 168
// module chunks = 0